<template>
  <div class="progress-container">
    <div class="progress-header">
      <span class="step" v-for="(step, i) in steps" :key="i">{{ $t(`global.${step}`) }}</span>
    </div>
    <div class="progress-fillbar">
      <div
        class="progress-bar"
        role="progressbar"
        aria-valuemin="0"
        aria-valuemax="100"
        :style="fillPercentage"
      ></div>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";

export default {
  name: "ProgressBar",
  props: {
    steps: {
      validator: (value) => {
        if (!Array.isArray(value)) {
          return false;
        }

        return value.filter((item) => typeof item !== "string").length === 0;
      },
    },
    currentStep: String,
  },
  setup(props) {
    const fillPercentage = computed(() => {
      const stepIndex = props.steps.indexOf(props.currentStep);
      const percentage = 100 * ((stepIndex + 1) / props.steps.length);
      const adjusted = percentage - 100 / (2 * props.steps.length);
      return {
        width: `${adjusted}%`,
      };
    });

    return {
      fillPercentage,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";
$containerMaxWidth: 600px;

.progress-container {
  max-width: $containerMaxWidth;
  width: 100%;
  margin: 0 auto 2rem;

  .progress-header {
    display: flex;
    justify-content: space-around;
    align-items: center;

    .step {
      // width: 150px;
      flex: 1;
      font-size: 14px;
      text-align: center;
    }
  }

  .progress-fillbar {
    display: block;
    margin: 10px auto 40px auto;
    width: 100%;
    max-width: $containerMaxWidth;
    text-align: center;
    border-radius: 1px;
    padding: 4px;

    .progress-bar {
      height: 5px;
    }
  }
}
</style>
